import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/axios.js";
import { Link } from "react-router-dom";



export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [baladiya, setBaladiya] = useState("");
  const [userType, setUserType] = useState("Client");
  const [workType, setWorkType] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleRegister = async () => {
    if (!email || !password || !name) {
      setError("يرجى ملء جميع الحقول المطلوبة");
      return;
    }

    try {
      const response = await api.post("/register", {
        name,
        email,
        password,
        role: userType === "Client" ? "client" : "user",
        type_work: workType,
        blaidait: baladiya,
        phone: phone
      });

      console.log(response.data);

      navigate("/verify-otp", { state: { email } });
    } catch (err) {
      if (err.response && err.response.data) {
        setError(err.response.data.message || "خطأ في التسجيل");
      } else {
        setError("خطأ في الاتصال بالخادم");
      }
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.topContent}>
        <center>
          <img
            src="/images/logo.png"
            alt="شعار الوسيط القضائي"
            className="welcome-image"
          />
        </center>
        <h2 style={styles.welcomeText}>مرحباً بك! ⚖️</h2>
        <p>أنشئ حسابك للمتابعة</p>
      </div>

      <div style={styles.card}>
        <h2 style={styles.title}>إنشاء حساب جديد</h2>

        {/* الاسم */}
        <input
          type="text"
          placeholder="الاسم الكامل"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={styles.input}
        />

        {/* البريد الإلكتروني */}
        <input
          type="email"
          placeholder="البريد الإلكتروني"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
        />

        {/* كلمة المرور */}
        <input
          type="password"
          placeholder="كلمة المرور"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
        />

        {/* بيانات خاصة بمزود الخدمة */}
        {userType !== "Client" && (
          <>
            <input
              type="text"
              placeholder="رقم الهاتف"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              style={styles.input}
            />
            <select
              value={baladiya}
              onChange={(e) => setBaladiya(e.target.value)}
              style={styles.input}
            >
              <option value="">اختر البلدية</option>
              <option value="عين عبيد">عين عبيد</option>
              <option value="زيغود يوسف">زيغود يوسف</option>
              <option value="ابن زياد">ابن زياد</option>
              <option value="حامة بوزيان">حامة بوزيان</option>
              <option value="الخروب">الخروب</option>
              <option value="قسنطينة">قسنطينة</option>
            </select>

            <select
              value={workType}
              onChange={(e) => setWorkType(e.target.value)}
              style={styles.input}
            >
              <option value="">اختر نوع العمل</option>
              <option value="lawyer">محامون</option>
              <option value="notary">موثقون</option>
              <option value="translator">مترجمون</option>
              <option value="judicial_expert">خبراء قضائيون</option>
            </select>
          </>
        )}

        {/* نوع المستخدم */}
        <select
          value={userType}
          onChange={(e) => setUserType(e.target.value)}
          style={styles.input}
        >
          <option value="Client">زبون</option>
          <option value="User">مزود خدمة</option>
        </select>

        {/* رسالة الخطأ */}
        {error && <p style={styles.error}>{error}</p>}

        {/* زر التسجيل */}
        <button onClick={handleRegister} style={styles.button}>
          تسجيل
        </button>

        <p style={styles.link}>
          هل لديك حساب بالفعل؟{" "}
          <Link style={{ color: "#81df43" }} to="/login">
            تسجيل الدخول
          </Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: "#e8eee7ff",
    height: "100vh",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    fontFamily: "'Cairo', sans-serif",
    padding: "20px",
    direction: "rtl", // مهم لجعل الصفحة من اليمين لليسار
  },
  topContent: {
    textAlign: "center",
    marginBottom: "20px",
  },
  welcomeText: {
    fontSize: "1.2rem",
    color: "#0f172a",
    marginBottom: "20px",
  },
  card: {
    backgroundColor: "#fff",
    padding: "2rem",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    width: "100%",
    maxWidth: "400px",
    textAlign: "center",
  },
  title: {
    marginBottom: "1.5rem",
    color: "#1e293b",
  },
  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "15px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  },
  button: {
    backgroundColor: "#81df43ff",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    width: "100%",
    fontSize: "1rem",
  },
  error: {
    color: "red",
    marginBottom: "10px",
    fontSize: "0.9rem",
  },
  link: {
    marginTop: "1rem",
    fontSize: "0.9rem",
  },
};
